import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings.js";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const GreenLink = tw.a`text-brand5 hocus:text-brand4`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-8 md:mt-0`,
  props.textOnLeft ? tw`md:mr-8 lg:mr-16 md:order-first` : tw`md:ml-8 lg:ml-16 md:order-last`
]);
const TextContent = tw.div`lg:py-8`;

const Heading = tw(SectionHeading)`text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Meta = tw.p`text-center md:text-left text-sm md:text-base font-medium text-brand4 mt-2 mb-4`;
const Description = tw.p`text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-brand5 mt-4`;
const SubHeading = tw.h2`text-center md:text-left text-xl md:text-2xl font-bold text-brand5 mt-10 mb-2`;
const List = tw.ul`mt-2 mb-2 pl-5 list-disc text-center md:text-left`;
const ListItem = tw.li`text-sm md:text-base lg:text-lg font-medium leading-relaxed text-brand5 mt-2`;

const PrivacyPolicy = ({textOnLeft = false}) => {
  return (
    <div id="nav-privacy">
      <Container>
        <TwoColumn>
          <TextColumn textOnLeft={textOnLeft}>
            <TextContent>
              <Heading>Privacy and Cookie Policy</Heading>
              <Meta>Last updated: 6 October 2026</Meta>

              <Description>
                This policy explains how Clarebrand Village Hall Committee (Scottish Charity
                SC008463) handles personal information collected through this website.
              </Description>

              <SubHeading>What we collect</SubHeading>
              <Description>
                We only collect personal details when you choose to send them to us. That happens when you use:
              </Description>
              <List>
                <ListItem>
                  the <GreenLink href="/book">contact / booking form</GreenLink> — typically name,
                  email address, preferred date and time, message, and any event details you include; or
                </ListItem>
                <ListItem>
                  the mailing list signup — your email address, so we can send hall updates you asked for.
                </ListItem>
              </List>

              <SubHeading>How we use your information</SubHeading>
              <Description>
                Contact and booking submissions are used so hall managers can read your enquiry,
                reply, and arrange hire where appropriate. Mailing list addresses are used only to
                send relevant Clarebrand Village Hall communications. We do not send unsolicited
                marketing emails beyond the list you joined.
              </Description>
              <Description>
                Form submissions are processed by our hosting provider (Netlify Forms). We keep
                information only as long as needed to handle your request, run the hall, or keep
                you on a list you joined, then delete or archive it when it is no longer required.
              </Description>

              <SubHeading>Sharing</SubHeading>
              <Description>
                We do not sell your personal information. We only share it with service providers
                who help us operate the site (such as form hosting or email delivery), where sharing
                is needed to fulfil a request you make, or where we are legally required to do so.
              </Description>

              <SubHeading>Your rights</SubHeading>
              <Description>
                We aim to follow UK GDPR and data protection good practice. If you want us to
                update or delete information we hold about you, or to leave the mailing list,
                please <GreenLink href="/book">contact us</GreenLink> and we will help where we can.
              </Description>

              <SubHeading>Cookies</SubHeading>
              <Description>
                This website uses cookies for basic site experience, including remembering your
                cookie consent choice. We do not run advertising trackers. Essential technical
                cookies may also be set by our hosting platform or by third-party sites you visit
                through our links (for example Facebook or payment providers); those are outside
                our direct control.
              </Description>

              <SubHeading>Contact</SubHeading>
              <Description>
                Questions about this policy can be sent through our{" "}
                <GreenLink href="/book">contact form</GreenLink>. Related website rules are in our{" "}
                <GreenLink href="/terms">Terms of Service</GreenLink>.
              </Description>
              <Description>
                Clarebrand Village Hall Committee · Clarebrand · DG7 3AH · Scottish Charity SC008463
              </Description>
            </TextContent>
          </TextColumn>
        </TwoColumn>
      </Container>
    </div>
  );
};

export default PrivacyPolicy
